// Implementação web de `PlataformaApi` (plataforma/tipos.ts): mesma origem e cookie de sessão, como sempre.
import type { PlataformaApi } from "../tipos";

export const baseApi: PlataformaApi["baseApi"] = "";

export const credenciaisApi: PlataformaApi["credenciaisApi"] = "same-origin";

/** O cookie `gs_sessao` vai sozinho: nenhum cabeçalho de credencial. */
export function cabecalhosCredencial(): Record<string, string> | undefined {
  return undefined;
}

/** Web: o cookie é a sessão; não há troca a acompanhar aqui. */
export function marcaDaSessao(): number {
  return 0;
}

/** Nada a fazer no web (cookie httpOnly). Nunca chamado no bundle web: cliente.ts guarda com `__ALVO__`. */
export async function aoResponder(_caminho: string, _resposta: Response | null, _marca: number): Promise<void> {}
